/* eslint-disable */
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type LeaveDepartment = {
  _id: string;
  name: string;
};

export type LeaveUser = {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
};

export type LeaveData = {
  _id: string;
  leaveType: "sick" | "casual" | "annual" | string;
  fromDate: string;
  toDate: string;
  numberOfDays: number;
  unpaidDays: number;
  status: string;
  department?: LeaveDepartment;
  user?: LeaveUser;
};

export type GetLeaveByIdResponse = {
  success: boolean;
  message?: string;
  data?: LeaveData;
};

const getLeaveById = async (leaveId: string) => {
  const res = await customAxios.get<GetLeaveByIdResponse>(
    `/leaves/leave/${leaveId}`
  );
  return res.data;
};

export const useGetLeaveById = (leaveId?: string) => {
  const queryClient = useQueryClient();

  return useQuery<GetLeaveByIdResponse, AxiosError>(
    ["leaveById", leaveId],
    () => {
      if (!leaveId) {
        return Promise.reject(new Error("leaveId is required"));
      }
      return getLeaveById(leaveId);
    },
    {
      enabled: Boolean(leaveId),

      staleTime: 1000 * 60 * 2,
      onError: (error: AxiosError) => {
        showNotification({
          title: "Failed to load leave",
          message:
            (error as any)?.response?.data?.message ||
            "Unable to fetch leave details. Please try again.",
          color: "red",
        });
      },

      retry: 1,
    }
  );
};
